export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7993.3aecb28a.jpg";